import { useFormik } from "formik"
import { useEffect, useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"
import { ContentHeader } from "../../components"
import { layDSTatCaQuyen, luuQuyen, xoaQuyen } from "../../services/quyen"
import * as Yup from 'yup';
import { toast } from "react-toastify"
import { Link, useNavigate } from "react-router-dom"
import { Input } from "antd"
import { Links } from "../../helpers/Links"

const ChiTietQuyen = () => {
    const { TextArea } = Input;
    const navigate = useNavigate();
    const [title, setTitle] = useState('');
    const [idQuyen, setIdQuyen] = useState<number>(0);
    const [openModalLuu, setOpenModalLuu] = useState < boolean>(false);
    const [openModalXoa, setOpenModalXoa] = useState<boolean>(false);
    const { handleChange, values, handleSubmit, touched, errors, setFieldValue, setErrors, setTouched } = useFormik({
        initialValues: {
            "id": 0,
            "tenQuyen": "",
            "ghiChu": ""
        },
        validationSchema: Yup.object({
            tenQuyen: Yup.string().required('Bắt buộc')
        }),
        onSubmit: (values) => {
            setOpenModalLuu(true)
        }
    });
    const layTenQuyen = async () => {
        var data = await layDSTatCaQuyen();
        var quyen = data.find((item) => item.id === id);
        if (quyen != null) {
            setFieldValue("tenQuyen", quyen?.tenQuyen);
            setFieldValue("ghiChu", quyen?.ghiChu);
        }
        else {
            toast.error('Quyền không tồn tại hoặc đã bị xoá')
            navigate("/quyen")
        }
    }
    let id = 0;
    const onSave = async (request: any) => {
        let rs = await luuQuyen(request);
        if (rs === true) {
            toast.success(request.id > 0 ? 'Cập nhật quyền thành công' : 'Tạo mới quyền thành công')
            navigate("/quyen")
            setOpenModalLuu(false)
        }
        else {
            toast.success(request.id > 0 ? 'Cập nhật quyền không thành công' : 'Tạo mới quyền không thành công')
            setOpenModalLuu(false)
        }
    };
    const onDelete = async (id: number) => {
        let rs = await xoaQuyen(id);
        if (rs === true) {
            toast.success('Xoá quyền thành công');
            navigate("/quyen")
            setOpenModalXoa(false)
        }
        else {
            toast.success('Xoá quyền không thành công')
            setOpenModalXoa(false)
        }
    }
    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        id = parseInt(params.get('id') || '');
        if (id > 0) {
            setTitle('Chỉnh sửa quyền');
            setFieldValue("id", id);
            setIdQuyen(id);
            layTenQuyen()
        }
        else {
            setTitle('Tạo mới quyền');
            setFieldValue("id", 0)
            setIdQuyen(0);
        }
    }, []);
    return <section>
        <ContentHeader title={title} />
        <Modal show={openModalLuu} onHide={() => setOpenModalLuu(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Bạn có muốn {idQuyen > 0 ? "cập nhật quyền" : "tạo mới quyền"} không?
            </Modal.Body>
            <Modal.Footer style={{
                "display": "flex",
                "justifyContent": "space-between"
            }}>
                <Button variant="secondary" className="btn-sm" onClick={() => setOpenModalLuu(false)}>
                    Đóng
                </Button>
                <Button variant="primary" className="btn-sm" onClick={() => onSave(values)}>
                    {idQuyen > 0 ? "Cập nhật" : "Tạo mới"}
                </Button>
            </Modal.Footer>
        </Modal>
        <Modal show={openModalXoa} onHide={() => setOpenModalXoa(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Xóa quyền</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Bạn có muốn xóa quyền <strong>{values?.tenQuyen}</strong> không?
                <br />
                <strong><span className="text-red">Lưu ý:</span></strong> Sẽ xóa các chức năng liên quan.
            </Modal.Body>
            <Modal.Footer style={{
                "display": "flex",
                "justifyContent": "space-between"
            }}>
                <Button variant="secondary" className="btn-sm" onClick={() => setOpenModalXoa(false)}>
                    Đóng
                </Button>
                <Button variant="danger" className="btn-sm" onClick={() => onDelete(idQuyen)}>
                    Xóa
                </Button>
            </Modal.Footer>
        </Modal>
        <form className="card card-primary card-outline" onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
        }}>
            <div className="card-header">
                <h3 className="card-title">{title}</h3>
                <div className="float-right card-tools">
                </div>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-sm-12">
                        <form className="form-vertically center" style={{ "display": "flex", "justifyContent": "center", "flexDirection": "column", "alignItems": "center" }} >
                            <div className="form-group row col-sm-12">
                                <label className="col-sm-2 control-label">Tên quyền <span className="text-red">*</span>: </label>
                                <div className="col-sm-10">
                                    <Form.Control
                                        id="tenQuyen"
                                        name="tenQuyen"
                                        type="text"
                                        placeholder="Tên quyền"
                                        onChange={handleChange}
                                        value={values.tenQuyen}
                                        isValid={touched.tenQuyen && !errors.tenQuyen}
                                        isInvalid={touched.tenQuyen && !!errors.tenQuyen}
                                    />
                                    {touched.tenQuyen && errors.tenQuyen ? (
                                        <Form.Control.Feedback type="invalid">
                                            {errors.tenQuyen}
                                        </Form.Control.Feedback>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row col-sm-12">
                                <label className="col-sm-2 control-label">Ghi chú:</label>
                                <div className="col-sm-10">
                                    <TextArea rows={2} placeholder="" maxLength={1000} value={values.ghiChu} onChange={(e) => setFieldValue("ghiChu", e.target.value)} />
                                </div>
                            </div>
                            
                        </form>
                    </div>
                </div>
            </div>
            <div className="card-footer row">
                <div className="col-sm-4">
                    <Link to={Links.Quyen.DanhSach} className="btn btn-secondary" title="Quay lại">Quay về<i className="fa fa-arrow-left ml-2" /></Link>
                </div>
                <div className="col-sm-8">
                    <Button className="float-right btn btn-success btn-secondary" style={{ "marginLeft": "10px" }} type="submit" title="Lưu">Lưu <i className="fa fa-save" /></Button>
                    {idQuyen > 0 ?
                        <Button className="float-right btn btn-danger btn-secondary" onClick={() => setOpenModalXoa(true)} type="button" title="Xóa quyền" >Xóa <i className="fas fa-trash-alt" /></Button>
                        : null}
                </div>
            </div>
        </form>
    </section>
}

export default ChiTietQuyen